import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamondShine = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.32 10.74 1 6.54 3.58 3.9l4.26 4.32zm16.74-4.68V0h3.6v6.06zm20.16 4.68L39.7 8.22l4.32-4.32 2.52 2.64zM23.86 48 3.94 28.44h39.84zm-9.72-35.58h19.38l10.26 12.42H3.94z" })
});
export default SvgDiamondShine;
